import {
  computed,
  ComputedGetter,
  ComputedRef,
  DebuggerOptions,
  MaybeRefOrGetter,
  toValue,
} from 'vue'

export function computedIter<T>(fn: ComputedGetter<Iterable<T>>): ComputedRef<T[]> {
  return computed(() => Array.from(fn()))
}

export function areSetsEqual<T extends string | number | symbol>(
  firstIterable: Iterable<T>,
  secondIterable: Iterable<T>,
): boolean {
  const set1 = new Set(firstIterable)
  const set2 = new Set(secondIterable)

  if (set1.size !== set2.size) return false

  for (const item of set1) {
    if (!set2.has(item)) return false
  }

  return true
}

export async function fromAsync<T>(iterable: AsyncIterable<T>): Promise<T[]> {
  // Typescript is unhappy with Array.fromAsync (TS2339)
  const result: T[] = []
  for await (const item of iterable) {
    result.push(item)
  }
  return result
}

export function useArray<T>(
  iterable: MaybeRefOrGetter<Iterable<T>>,
  debugOptions?: DebuggerOptions,
) {
  return computed(() => Array.from(toValue(iterable)), debugOptions)
}

export function useMap<T extends { id: unknown }>(iterable: T[]) {
  return computed(() => {
    const map = new Map<T['id'], T>()
    for (const item of iterable) map.set(item.id, item)
    return map
  })
}

export function omitUndefined<T extends Record<string, unknown>>(obj: T) {
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined)) as {
    [K in keyof T as T[K] extends undefined ? never : K]: T[K]
  }
}
